<template>
  <div class="debt-providers-actions">
    <div class="debt-providers-actions__container d-flex justify-content-center">
      <b-dropdown 
        size="sm" 
        id="dropdown-actions" 
        right
        class="debt-providers-actions__dropdown"
        :aria-label="`Hành động cho nhà cung cấp ${item.name}`"
      >
        <template slot="button-content">
          <i
            class="debt-providers-actions__icon flaticon2-settings"
            aria-hidden="true"
          ></i>
          <span class="sr-only">Mở menu hành động</span>
        </template>

        <!-- View detail action -->
        <b-dropdown-item 
          @click="onViewDetail"
          class="debt-providers-actions__item"
          :aria-label="`Xem chi tiết công nợ của ${item.name}`"
        >
          <span class="debt-providers-actions__item-content">
            <i class="debt-providers-actions__item-icon flaticon-eye" aria-hidden="true"></i>
            &nbsp; Chi tiết
          </span>
        </b-dropdown-item>

        <!-- Create cash transaction action -->
        <b-dropdown-item class="debt-providers-actions__item">
          <router-link
            :to="cashTransactionRoute"
            class="debt-providers-actions__link"
            :aria-label="`Lập phiếu chi tiền mặt cho ${item.name}`"
          >
            <span class="debt-providers-actions__item-content">
              <i class="debt-providers-actions__item-icon far fa-money-bill-alt" aria-hidden="true"></i>
              &nbsp; Lập phiếu chi
            </span>
          </router-link>
        </b-dropdown-item>

        <!-- Create bank transaction action -->
        <b-dropdown-item class="debt-providers-actions__item">
          <router-link
            :to="bankTransactionRoute"
            class="debt-providers-actions__link"
            :aria-label="`Lập phiếu báo nợ ngân hàng cho ${item.name}`"
          >
            <span class="debt-providers-actions__item-content">
              <i class="debt-providers-actions__item-icon fas fa-money-check-alt" aria-hidden="true"></i>
              &nbsp; Lập phiếu báo nợ
            </span>
          </router-link>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebtProvidersActions',
  props: {
    /**
     * Provider item data
     */
    item: {
      type: Object,
      required: true,
      validator: (item) => {
        return item && typeof item === 'object' && item.id && item.name;
      },
    },
  },
  computed: {
    /**
     * Route configuration for cash transaction
     */
    cashTransactionRoute() {
      return {
        name: 'transaction',
        params: {
          mainModelProp: {
            contactType: '2',
            type: '2',
            contactId: this.item.id,
            contactName: this.item.name,
          },
          mode: 'cash',
          action: 'add',
          id: 'new',
        },
      };
    },

    /**
     * Route configuration for bank transaction
     */
    bankTransactionRoute() {
      return {
        name: 'transaction',
        params: {
          mainModelProp: {
            contactType: '2',
            type: '4',
            contactId: this.item.id,
            contactName: this.item.name,
          },
          mode: 'bank',
          action: 'add',
          id: 'new',
        },
      };
    },
  },
  methods: {
    /**
     * Handle view detail action
     */
    onViewDetail() {
      this.$emit('view-detail', this.item);
    },

    /**
     * Handle create cash transaction action
     */
    onCreateCashTransaction() {
      this.$emit('create-cash-transaction', this.item);
    },

    /**
     * Handle create bank transaction action
     */
    onCreateBankTransaction() {
      this.$emit('create-bank-transaction', this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.debt-providers-actions {
  &__container {
    min-height: 2rem;
    align-items: center;
  }

  &__dropdown {
    .btn {
      border: none;
      background: transparent;
      padding: 0.25rem 0.5rem;
      
      &:hover {
        background-color: #f8f9fa;
      }

      &:focus {
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
    }
  }

  &__icon {
    font-size: 1rem !important;
    padding-right: 0;
    color: #6c757d;
    
    &:hover {
      color: #495057;
    }
  }

  &__item {
    padding: 0;
    
    &:hover {
      background-color: #f8f9fa;
    }

    &:focus {
      background-color: #e9ecef;
      outline: 2px solid #007bff;
      outline-offset: -2px;
    }
  }

  &__item-content {
    color: #3f4254;
    font-size: 1rem;
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    text-decoration: none;
    
    &:hover {
      color: #1e2022;
    }
  }

  &__item-icon {
    font-size: 1rem;
    width: 1.25rem;
    text-align: center;
  }

  &__link {
    color: inherit;
    text-decoration: none;
    display: block;
    width: 100%;
    
    &:hover {
      color: inherit;
      text-decoration: none;
    }

    &:focus {
      color: inherit;
      text-decoration: none;
      outline: none;
    }
  }

  // Responsive design
  @media (max-width: 768px) {
    &__item-content {
      font-size: 0.875rem;
      padding: 0.75rem 1rem;
    }

    &__item-icon {
      font-size: 1.125rem;
    }
  }
}

// Screen reader only content
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

// Dropdown menu styling
:deep(.dropdown-menu) {
  border: 1px solid #e9ecef;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.375rem;
  padding: 0;
  min-width: 10rem;

  .dropdown-item {
    padding: 0;
    border: none;
    background: none;
    
    &:hover,
    &:focus {
      background-color: #f8f9fa;
    }

    &:active {
      background-color: #e9ecef;
    }
  }
}
</style>
